<app-invitation-b2b-page-wrapper>
    <ng-container [ngSwitch]="currentInvitationStep">
        <ng-container *ngSwitchCase="invitationStep.invitationB2bInit">
            <div class="invitation">
            <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                         class="margin-bottom-50">
            </app-header-invitation-b2b-partnership-logos>
            <div class='invitation__details'>
                <div class='invitation__details--title'>
                    {{ 'Detail des acces que souhaite vous accorder $client$' | transloco: {
                        client: invitation.account.organization_name
                    } }}
                </div>
                <div class="invitation__details--contact"
                     [innerHtml]="'Adresse mail de $client$ : <strong>$mail$</strong>' | transloco: {
                        client: invitation.account.organization_name,
                        mail: invitation.invited_by.email
                        }">
                </div>
            </div>
            <mat-card class="invitation__card card">
                <mat-card-content>
                    <div class="invitation__access margin-bottom-20">
                        <app-invitation-b2b-access-list [invitation]="invitation"></app-invitation-b2b-access-list>
                    </div>
                    <mat-card class="invitation__message margin-bottom-40">
                        <img class="margin-bottom-10"
                             src="/assets/images/ui/idea_alt.svg"
                             alt="{{'Ampoule' | transloco}}" />
                        <span>
                            {{'En tant que partenaire, vous devrez assurer le support des produits de ce client dont vous aurez la gestion.' | transloco}}
                            <br />
                            <span
                                (click)="openFaq(2064)"
                                class="link blue">
                                {{ ('En savoir plus' | transloco) }}
                            </span>
                        </span>
                    </mat-card>
                    <div class="invitation__buttons text-center">
                        <div class="invitation__buttons--title margin-bottom-30">
                            {{ 'Que souhaitez-vous faire ?' | transloco }}
                        </div>
                        <a mat-raised-button
                           [buttonLoader]="rejectLoading"
                           color="danger"
                           (click)="rejectInvitation()">
                            {{ ('Refuser l\'invitation' | transloco) }}
                        </a>
                        <a mat-raised-button
                           color="primary"
                           [buttonLoader]="acceptLoading"
                           (click)="acceptInvitation()">
                            {{ ('Accepter l\'invitation' | transloco) }}
                        </a>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
            <!-- <pre>{{invitation | json}}</pre> -->
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bAccepted">
            <app-invitation-b2b-accepted [invitation]="invitation"
                                         [partnershipId]="partnershipId"
                                         [type]="'partner'"></app-invitation-b2b-accepted>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bRejected">
            <app-invitation-b2b-rejected [invitation]="invitation"
                                         [type]="'partner'"></app-invitation-b2b-rejected>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bAlreadyAccepted">
            <ng-container *ngTemplateOutlet="alreadyChecked">
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bAlreadyRejected">
            <ng-container *ngTemplateOutlet="alreadyChecked">
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bWrongAccount">
            <app-invitation-b2b-wrong-account [invitation]="invitation"></app-invitation-b2b-wrong-account>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bOnlyForOwners">
            <app-invitation-b2b-only-for-owner [invitation]="invitation"
                                               (invitationResent)="invitationResent()">
            </app-invitation-b2b-only-for-owner>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bInvitationResent">
            <app-invitation-b2b-resend-success [invitation]="invitation"
                                               [type]="'partner'"></app-invitation-b2b-resend-success>
        </ng-container>
    </ng-container>
</app-invitation-b2b-page-wrapper>
<ng-template #alreadyChecked>
    <app-invitation-b2b-partner-already-checked [invitation]="invitation"
                                                [status]="currentInvitationStep">
    </app-invitation-b2b-partner-already-checked>
</ng-template>
